export const QuestionMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden
    >
      <circle cx="24" cy="24" r="24" fill="#464646" />
      <path d="M25.75 36V32.5H22.25V36H25.75Z" fill="white" />
      <path
        d="M27.5 28.0673C29.6525 26.865 31 24.4535 31 22C31 18.3481 28.375 15 24 15C20.1342 15 17 18.1342 17
        22H20.5C20.5 20.0662 22.0662 18.5 24 18.5C25.9338 18.5 27.5 20.0662 27.5 22C27.5 23.295 26.7668 24.4325 25.75
        25.0082C23.6395 26.0792 22.25 28.146 22.25 30.75H25.75C25.75 29.5075 26.471 28.5747 27.5 28.0673Z"
        fill="white"
      />
    </svg>
  );
};
